import { useAuditClientConfigQuery } from '@app/modules/audit/modules/station-audit/hooks/useAuditClientConfigQuery';

export function useEvidenceExportPathFormats(returnNullIfLoading = false) {
  const auditClientConfigQuery = useAuditClientConfigQuery();
  const pathFormats = auditClientConfigQuery.data?.evidenceExport?.pathFormats ?? [];

  return returnNullIfLoading
    ? auditClientConfigQuery.data === undefined
      ? null
      : pathFormats
    : pathFormats;
}
